/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  app.NewsView = app.RestCommonView.extend({
    el: '.news-list_page',
    newsItemsTemplateSelector: '#news-list-items',
    newsFilteredBlockTemplateSelector: '#news-filtered-block',
    selectedCategories: [],

    events: {
      'click .category-news-item input': 'changeCategoryFilter',
      'click .filtered-block .but-close': 'removeCategoryFilter',
      'click .filter-drop': 'resetCategoryFilter',
      'click .js-filter-news_but': 'openNewsFilter',
      'click .js-but-apply': 'closeNewsFilter',
      'click .news-tab': 'closeNewsFilter'
    },
    additionalOptions: ['router', 'scrollHolderClass'],
    /**
     * @inheritDoc
     */
    run: function () {
      // templates
      this.newsItemsTemplate = app.helpers.TemplateHelper.getTemplate(this.newsItemsTemplateSelector);
      this.newsFilteredBlockTemplate = app.helpers.TemplateHelper.getTemplate(this.newsFilteredBlockTemplateSelector);
      this.checkSelectedCategories();
      // слушаем событие изменения GET параметров
      this.listenTo(this.model, 'sync', this.render);
      this.listenTo(this.router, 'change-category-filter', this.choice);
      // инициализируем паджинацию
      var PaginationView = app.PaginationView;
      if (app.isMobile) {
        PaginationView = app.MobilePaginationView;
      }
      app.paginationView = new PaginationView({
        model: this.model,
        router: this.router
      });
      // слушаем событие перехода на другую страницу через пагинацию
      this.listenTo(this.router, 'change-page', function () {
        this.scrollToTop();
        this.choice();
      });
      this.addVideos();
    },

    /**
     * @inheritDoc
     */
    render: function () {
      // отменяем рендер при первой загрузке страницы
      if (this.model.fetchCounter <= 1) {
        app.preloader.remove();
        return;
      }
      this.$('#news_list').html(this.newsItemsTemplate({
        news: this.model.models
      }));
      this.$('.filtered-block').replaceWith(this.newsFilteredBlockTemplate({
        categories: this.selectedCategories
      }));
      app.preloader.remove();
    },

    /**
     * Заполение массива выбранных категорий
     * @return {string}
     */
    checkSelectedCategories: function () {
      var result = [];
      this.selectedCategories = [];
      $('.category-news-item input').each(function (index, elem) {
        var $elem = $(elem);
        if ($elem.is(':checked')) {
          this.selectedCategories.push({
            id: $elem.data('id'),
            name: $elem.parent().text(),
            slug: $elem.val()
          });
          result.push($elem.val());
        }
      }.bind(this));
      return result.join(',');
    },

    /**
     * Смена фильтра категорий
     */
    changeCategoryFilter: function () {
      var categories = this.checkSelectedCategories();
      if (!categories) {
        categories = 'null';
      }
      this.router.navigate('/', {
        trigger: true
      }, {
        'category': categories
      });
    },

    /**
     * Сброс фильтра категорий
     */
    resetCategoryFilter: function () {
      $('.category-news-item input:checked').prop('checked', false);
      this.changeCategoryFilter();
    },

    /**
     * Удаление фильтра категорий
     * @param {jQuery} e
     */
    removeCategoryFilter: function (e) {
      $('.category-news-item input[data-id=' + e.target.dataset.id + ']').trigger('click');
    },

    /**
     * Открытие таба с фильтрами
     */
    openNewsFilter: function () {
      this.$('.js-news-filter, .js-content_last-news').toggle();
    },

    /**
     * Закрытие таба с фильтрами
     */
    closeNewsFilter: function () {
      this.$('.js-news-filter').hide();
      this.$('.js-content_last-news, .js-filtered-block').show();
    },

    /**
     * Рендер прелоадера
     */
    choice: function () {
      app.preloader.render();
    },

    /**
     * Добавление видео с YouTube
     */
    addVideos: function () {
      var newsView = this;
      window.onYouTubeIframeAPIReady = function () {
        newsView._makePlayers();
      };
      this._addIpiScript();
    },

    /**
     * Загрузка скрипт YouTube API
     * @private
     */
    _addIpiScript: function () {
      var tag = document.createElement('script'),
        firstScriptTag = document.getElementsByTagName('script')[0];
      tag.src = 'https://www.youtube.com/player_api';
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },

    /**
     * Создание ютуб плееров. Получаем айди видео из датасета дивов-контейнеров
     * @private
     */
    _makePlayers: function () {
      var videoDivs = document.querySelectorAll('.last-videobl .yt-player'),
        videosNumber = videoDivs.length,
        videoUrls = [],
        players = [],
        videoHeight = 112,
        events = {
          /**
           * Все видео при изменении состояния вызывают onPlayerStateChange
           */
          'onStateChange': this._onPlayerStateChange.bind(this, players)
        },
        lastVideoEvents = {
          'onStateChange': this._onPlayerStateChange.bind(this, players),
          /**
           * Последнее видео после загрузки показывает весь блок видео
           */
          'onReady': this._showVideosBlock
        };

      if (app.isMobile) {
        videoHeight = 170;
      }

      app.players = players;

      for (var i = 0; i < videosNumber; i++) {
        videoUrls.push(videoDivs[i].dataset.id);
        /**
         *  Плееры добавляются в элементы с id yt-player-1, yt-player-2 и т.д.
         */
        players[i] = new YT.Player('yt-player-' + i, {
          width: '100%',
          height: videoHeight,
          videoId: videoUrls[i],
          playerVars: {
            controls: 1,
            showinfo: 0,
            modestbranding: 0,
            frameborder: 0
          },
          /**
           * Последнее видео подписывается на другой список событий
           */
          events: (i != videosNumber - 1) ? events : lastVideoEvents
        });
      }
      window.onYouTubeIframeAPIReady = null;
    },

    /**
     * Вызывается при изменении состояния плеера
     * Если состояние становится PLAYING, ставим на паузу все остальные видео
     * @private
     * @param players список ютуб плееров
     * @param event событие
     */
    _onPlayerStateChange: function (players, event) {
      if (event.data == YT.PlayerState.PLAYING) {
        for (var i = 0; i < players.length; i++) {
          if (event.target != players[i]) {
            players[i].stopVideo();
          }
        }
      }
    },

    /**
     * Отобразить блок с видео. Вызывается после загрузки последнего плеера
     * @private
     */
    _showVideosBlock: function () {
      $('.last-videobl').removeClass('not_display');
    }

  });
})(jQuery);

}.call(window));